<template>
	<input type="password" 
		:id="id" 
		:name="getName" 
		:class="['c-input-password', 'c-input-native-base-restyle', cssClass, isValid == false ? 'is-invalid' : '']" 
		:style="getCssStyle"
		:maxlength="maxlength"
		:disabled="disabled"
		:value="modelValue"
		@input="onInput"
		data-lpignore="true"
	>

	<span class="validation-text" v-if="isValid == false && validationMessage != ''">
		<small style="color: red" v-html="validationMessage"></small>
	</span>
</template>





<script>
//Note: `data-lpignore="true"` to stop LastPass icon
import allFormElementPropsMixin from "./all-form-element-props-mixin";


export default {

	emits: ["change", "update:modelValue"],





	mixins: [allFormElementPropsMixin],





	props: {
		
		//TODO: Obsolete/deprecated. Don't remove until removing from implementations.
		initialValue: {
			type: String,
			default: ""
		},


		
		placeholder: {
			type: String,
			default: ""
		},


		
		maxlength: {
			type: String,
			default: ""
		},



        modelValue: {
            type: String,
            default: '',
            required: false
        },

	},





	data()
	{
		return {
			value: ""
		};
	},





	mounted()
	{
	},





	watch: {
	},





	computed: {
		getName() {
			return this.name ? this.name : this.id;
		}
	},





	methods: {
		onInput(event)
		{
			this.$emit('change', event.target.value);

			this.$emit('update:modelValue', event.target.value);
		},

	}
}
</script>





<style scoped lang="scss">
//@use "/assets/sass/styles-version-1.scss" as *;
	@use "/components/form-styles.scss" as *;

	
	.c-input-text 
	{
		width: 100%;
	}
</style>


